import {green, grey} from '@mui/material/colors';
import {StatusCode} from './types/statusCode';

export const colors = {
  'text--primary': '#000f4d',
  'icons--primary': '#5074F5',
  'bg--primary': '#E8F3F4',
  'bg--secondary': '#D2DEE2',
  'bg--on-white': '#f4f7f7',
  'bg--labelField': '#ECF1F4',
  'border--white--bg': '#D4D4D4',
  red: '#EB3333',
  green: '#2CC378',
};

export const statusColors: {
  [key in StatusCode]: {
    border: string;
    text: string;
    background: string;
  };
} = {
  CREATED: {
    text: '#3AC977',
    border: '#3AC977',
    background: '#fafbfb',
  },
  READY_TO_PROCESS: {
    text: '#FF9F00',
    border: '',
    background: '#FFECCC',
  },
  IMPORTING: {
    text: '',
    border: '',
    background: '',
  },
  IMPORTED: {
    text: '',
    border: '',
    background: '',
  },
  PROCESSING: {
    text: '#0D99FF',
    border: '',
    background: '#E6F5FF',
  },
  DONE: {
    text: '#3AC977',
    border: '',
    background: '#DAF5E6',
  },
  WAITING_FOR_START: {
    text: '#FF9F00',
    border: '',
    background: '#FFECCC',
  },
  FINISHED_SUCCESSFULLY: {
    text: '#3AC977',
    border: '',
    background: '#DAF5E6',
  },
  FINISHED_WITH_ERRORS: {
    text: '#FF5E5E',
    border: '',
    background: '#FFDEDE',
  },
  NOTIFYING: {
    text: '#0D99FF',
    border: '',
    background: '#E6F5FF',
  },
  IN_PROGRESS: {
    text: '#0D99FF',
    border: '',
    background: '#E6F5FF',
  },
  EXECUTED: {
    text: '#3AC977',
    border: '',
    background: '#DAF5E6',
  },
  REJECTED: {
    text: '#FF5E5E',
    border: '',
    background: '#FFDEDE',
  },
  CANCELLED: {
    text: '#FF5E5E',
    border: '',
    background: '#FFDEDE',
  },
  DELAYED: {
    text: '#00426947',
    border: '#00426947',
    background: '#E6F5FF',
  },
  APPROVED: {
    text: '#ab00ff',
    border: '#ab00ff',
    background: '#f2ccff8f',
  },
  ARCHIVED: {
    text: '#A8ACB0',
    border: '#A8ACB0',
    background: '',
  },
};

export const greenButtonStyle = {
  backgroundColor: green[500],
  '&:hover': {
    backgroundColor: green[600],
  },
};

export const greenButtonOutlinedStyle = {
  borderColor: `${green[500]} !important`,
  color: `${green[500]} !important`,
  '&:hover': {
    borderColor: `${green[700]} !important`,
  },
};

export const blackButtonOutlinedStyle = {
  borderColor: `#000 !important`,
  color: `#000 !important`,
  '&:hover': {
    borderColor: `${grey[800]} !important`,
  },
};
